import { render, staticRenderFns } from "./ChangeLocale.vue?vue&type=template&id=a13170ea&"
import script from "./ChangeLocale.vue?vue&type=script&lang=js&"
export * from "./ChangeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports